import React from 'react';
import { categorical } from '../../../utils/chartTheme';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const MetricsOverview = ({ stats }) => {
  const { t } = useTranslation('admin');

  const metrics = [
    { key: 'totalUsers', value: stats?.totalUsers || 0, icon: 'Users', accent: categorical(0) },
    { key: 'totalConferences', value: stats?.totalConferences || 0, icon: 'FolderOpen', accent: categorical(2) },
    { key: 'totalSubmissions', value: stats?.totalSubmissions || 0, icon: 'FileText', accent: categorical(4) },
    { key: 'totalReviews', value: stats?.totalReviews || 0, icon: 'ClipboardCheck', accent: categorical(1) }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-8">
      {metrics?.map((metric) => (
        <div
          key={metric?.key}
          className="group relative overflow-hidden rounded-lg border border-border bg-card p-5 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
        >
          {/* Top accent bar */}
          <span className="absolute inset-x-0 top-0 h-1" style={{ backgroundColor: metric?.accent }} />
          {/* Watermark icon */}
          <Icon
            name={metric?.icon}
            size={72}
            className="absolute -bottom-3 -end-3 opacity-[0.04] group-hover:opacity-[0.07] transition-opacity"
          />
          <div className="relative">
            <div
              className="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
              style={{ backgroundColor: `${metric?.accent}1a`, color: metric?.accent }}
            >
              <Icon name={metric?.icon} size={22} />
            </div>
            <p className="text-3xl md:text-4xl font-extrabold text-foreground tracking-tight tabular-nums">
              {Number(metric?.value)?.toLocaleString()}
            </p>
            <p className="text-xs md:text-sm text-muted-foreground mt-1">
              {t(`metricsOverview.${metric?.key}`)}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsOverview;
